import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const HeaderPageText = ({text, icon}) =>{

    return(
        <Box sx={{display: 'flex', alignItems: 'center', color: 'primary.text', mb: 0.5}}>
            {icon}
            <Typography 
                variant='h9'
                sx={{ ml: 1 }}
            >
                {text}
            </Typography>
        </Box>
    );
};

export default HeaderPageText;